var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "columnsBar", class: _vm.$.adding_panel },
    [
      _c("columns-bar-header", {
        attrs: {
          title: _vm.locales("custom_columns_adding_title"),
          "view-config": _vm.viewConfig,
          tabs: _vm.accessTabs,
          "back-button": true,
          "help-button": false,
        },
        on: {
          onChangeTab: _vm.changeTab,
          onClose: _vm.onClose,
          backClick: _vm.backClick,
        },
      }),
      _vm._v(" "),
      _c(_vm.currentComponent, {
        key: _vm.currentComponent,
        tag: "component",
        attrs: {
          "all-columns": _vm.allColumns,
          "project-columns-ids": _vm.projectColumnsIds,
          "new-column": _vm.newColumn,
        },
        on: {
          showExistingColumnsByUserValue: _vm.showExistingColumnsByUserValue,
          onReuseExistingColumn: function (id) {
            return _vm.$emit("onReuseExistingColumn", id)
          },
          redirectToSettings: function ($event) {
            return _vm.$emit("redirectToSettings")
          },
          showMarkerOnExistingTab: _vm.showMarkerOnExistingTab,
          changeView: function (view, tab) {
            return _vm.$emit("changeView", view, tab)
          },
          setNewColumnData: _vm.setNewColumnData,
          saveNewColumn: _vm.saveNewColumn,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }